export class CompanyBillingMethod {
  public id: number | null;
  public company_id: number | null;
  public billing_method_id: number | null;
  public invoice_code_id: number|null;
  public document_type_id: number|null;

  constructor(data: CompanyBillingMethodData | undefined | null = undefined) {
    if (data === undefined || data === null) {
      this.id = null;
      this.company_id = null;
      this.billing_method_id = null;
      this.invoice_code_id = null;
      this.document_type_id =null;
    }
    else {
      this.id = data.id;
      this.company_id = data.company_id;
      this.billing_method_id = data.billing_method_id;
      this.invoice_code_id = data.invoice_code_id;
      this.document_type_id = data.document_type_id;
    }
  }

  serializeData():CompanyBillingMethodData {
    return {
      id: this.id,
      company_id: this.company_id,
      billing_method_id: this.billing_method_id,
      invoice_code_id: this.invoice_code_id,
      document_type_id: this.document_type_id,
    }
  }
}

export type CompanyBillingMethodData = {
  id: number | null;
  company_id: number | null;
  billing_method_id: number | null;
  invoice_code_id: number|null;
  document_type_id: number|null;
}
